/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Validation_Message_RequiredInputs */



/**
* | output |
* | --- |
* | "Please describe your request." |
*
* @param {Support_Validation_Message_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const support_validation_message_required = /** @type {((inputs?: Support_Validation_Message_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Validation_Message_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte beschreibe dein Anliegen.")
	return /** @type {LocalizedString} */ ("Please describe your request.")
});